module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/mastercard-old-13fbb4177db7f17d85c2870d599c3aab.svg";